/**
 * 菜单接口
 */
import type { RouteComponent, RouteMeta } from 'vue-router'
import { baseURL } from '@/api/base' // 导入接口域名列表
import axios from '@/utils/http' // 导入http中创建的axios实例

//* 获取菜单
export type Menu = {
	children: Menu[] //子菜单
	component: string | RouteComponent // 组件路径 对应
	name?: string // 路由名称 对应 menuRouterName
	path: string // 菜单跳转路径 对应 menuHref
	meta: RouteMeta
	parentMenuId: IdType
	sortNo: string | number
	menuId: IdType
}
export const getMenu: () => Promise<Menu[]> = () => axios.get(`${baseURL}/api/sysMenu/getMenu`)

//* 获取按钮权限 todo 添加 字典管理的权限字段
export const getUserMenuPermissions: () => Promise<Recordable<Recordable<boolean>>> = () => axios.get(`${baseURL}/api/sysUser/getUserMenuPermissions`)

export default {
	getMenu,
	getUserMenuPermissions,
}
